<template>
    <div>
        <div class="container">
            <div class="logo">
                <span class="logo-img"></span>
                <span class="logo-text">修兀门店系统</span>
            </div>
            <div class="panel">
                <el-dropdown class="item user">
                    <span class="el-dropdown-link">
                        <span class="username"> {{ user.name }} </span>
                        <span class="order-msg"> 未指派订单: {{ orders }} </span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <!-- <el-dropdown-item icon="el-icon-s-home" @click.native="goHome()">首页</el-dropdown-item> -->
                        <el-dropdown-item icon="el-icon-phone-outline" @click.native="phoneCall">绑定电话</el-dropdown-item>
                        <el-dropdown-item icon="el-icon-edit-outline" @click.native="visibleDialog = true">修改密码</el-dropdown-item>
                        <el-dropdown-item icon="el-icon-unlock" @click.native="logout()">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="password">
            <el-dialog title="修改密码" :visible.sync="visibleDialog" center class="update-password" :close-on-click-modal="false" :close-on-press-escape="false">
                <el-form :model="passwordForm" :rules="rules" ref="passwordForm" label-width="140px" size="small">
                    <el-form-item label="原始密码" prop="oldPassword">
                        <el-input type="password" v-model="passwordForm.oldPassword" autocomplete="off" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="newPassword">
                        <el-input type="password" v-model="passwordForm.newPassword" autocomplete="off" show-password maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm">提 交</el-button>
                        <el-button @click="resetForm">重 置</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
            <el-dialog title="绑定电话" :visible.sync="visibleDialogs" center class="update-password" :close-on-click-modal="false" :close-on-press-escape="false">
                <el-form :model="phoneNumber" :rules="phoneRules" ref="phoneNumber" label-width="140px" size="small">
                    <el-form-item label="电话" prop="phone">
                        <el-input type="text" v-model="phoneNumber.phone"  maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="addPhone">确定</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import { OAuthUpdatePassword,OAuthBindPhone} from "../../api/requestOAuth";
    import { Message } from "element-ui";
    import { getUserInfo, getOrderInfo } from "@/api/request";
    export default {
        data() {
            return {
                intervalId: null,
                visibleDialog: false,
                visibleDialogs: false,
                userInfo: { name: "" },
                orders: 0,
                passwordForm: {
                    oldPassword: "",
                    newPassword: "",
                },
                phoneNumber:{
                    phone:"",
                },
                rules: {
                    oldPassword: [{ required: true, message: "请输入原始密码", trigger: "blur" }],
                    newPassword: [
                        { required: true, message: "请输入新密码", trigger: "blur" },
                        { min: 6, message: "请输入至少6位的密码", trigger: "blur" },
                        // { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z]{6,20}$/, message: "密码设置不符合要求", trigger: "blur" },
                    ],
                },
                phoneRules: {
                    phone: [{ required: true, message: "请输入手机号", trigger: "blur" },
                            { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: "手机号码格式不正确", trigger: "blur" },
                    ],
                },
            };
        },
        created() {
            this.getInfo();
            this.getOrders();
            this.dataRefreh();
        },
        computed: {
            user() {
                return this.userInfo;
            },
        },
        methods: {
            phoneCall(){
                this.$nextTick(() => {
                    console.log(this.userInfo);
                    if(this.userInfo.phone!==null){
                        this.phoneNumber.phone=this.userInfo.phone;
                    }else{
                        this.phoneNumber={};
                    }
                    this.visibleDialogs=true;
                    
                    this.$refs.phoneNumber.clearValidate();
                });
            },
            // 定时刷新数据函数
            dataRefreh() {
                // 计时器正在进行中，退出函数
                if (this.intervalId !== null) {
                    return;
                }
                // 计时器为空，操作
                this.intervalId = setInterval(() => {
                    console.log("刷新" + new Date());
                    this.getOrders();
                }, 120000);
            },
            // 停止定时器
            clear() {
                clearInterval(this.intervalId); // 清除计时器
                this.intervalId = null; // 设置为null
            },
            getInfo() {
                getUserInfo().then((res) => {
                    this.userInfo = res.data;
                });
            },
            getOrders() {
                getOrderInfo().then((res) => {
                    this.orders = res.data.total;
                });
            },
            logout() {
                const loading = this.$loading({
                    lock: true,
                    text: "正在退出...",
                });
                this.$store
                    .dispatch("auth/Logout")
                    .then(
                        () => {
                            this.$router.push({ path: "/login" });
                            loading.close();
                        },
                        () => {
                            this.$message({
                                showClose: true,
                                message: "操作失败",
                                type: "error",
                                onClose() {
                                    loading.close();
                                },
                            });
                        }
                    )
                    .catch((error) => {
                        this.$message({
                            showClose: true,
                            message: error instanceof Object && error.message !== undefined ? error.message : "Cannot parse response",
                            type: "error",
                            onClose() {},
                        });
                    });
            },
            goHome() {
                if (this.$route.path !== "/branchs") {
                    this.$router.push({ path: "/branchs" });
                }
            },
            addPhone(){
                this.$refs["phoneNumber"].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            text: "正在加载...",
                        });
                        OAuthBindPhone(this.$store.getters["auth/ACCESS_TOKEN"], this.phoneNumber).then(
                            (res) => {
                                Message({
                                    message: `${res.message}`,
                                    type: "success",
                                    duration: 1500,
                                });
                                this.visibleDialogs=false;
                                this.getInfo();
                                loading.close();
                            },
                            (res) => {
                                Message({
                                    message: `${res.message}`,
                                    type: "error",
                                    duration: 1500,
                                });
                                loading.close();
                            }
                        );
                    }
                });
            },
            submitForm() {
                this.$refs["passwordForm"].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            text: "正在加载...",
                        });
                        OAuthUpdatePassword(this.$store.getters["auth/ACCESS_TOKEN"], this.passwordForm).then(
                            (res) => {
                                Message({
                                    message: `${res.message}`,
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.logout();
                                    },
                                });
                                loading.close();
                            },
                            (res) => {
                                Message({
                                    message: `${res.message}`,
                                    type: "error",
                                    duration: 1500,
                                });
                                loading.close();
                            }
                        );
                    }
                });
            },
            resetForm() {
                this.$refs["passwordForm"].resetFields();
            },
        },
        destroyed() {
            // 在页面销毁后，清除计时器
            this.clear();
        },
    };
</script>
<style lang="scss" scoped>
    .container {
        background-color: rgb(166, 59, 58);
        padding: 0 !important;
        height: 36px !important;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .logo {
            margin-left: 20px;
            .logo-img {
                background-image: url("../../assets/images/favicon.png");
                background-size: 100%;
                background-position: 50% 50%;
                position: absolute;
                height: 35px;
                width: 35px;
                top: 0px;
                border-radius: 6px;
            }
            .logo-text {
                font-family: Source Han Sans CN;
                font-size: 18px;
                font-weight: 900;
                color: #fff;
                margin-left: 45px;
            }
        }
        .panel {
            padding-right: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .item {
                & + .item {
                    margin-left: 20px;
                }
                color: #fff;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .el-icon-message-solid,
                .el-i-down {
                    font-size: 14px;
                    margin-right: 4px;
                    position: relative;
                    top: 1px;
                }
                .el-i-down {
                    transform: rotate(90deg);
                }
                .el-badge {
                    ::v-deep .el-badge__content.is-fixed {
                        right: 0 !important;
                    }
                }
            }
            .el-dropdown.user {
                .el-dropdown-link {
                    color: #fff;
                    font-size: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .username {
                        margin-left: 5px;
                    }
                    .avatar {
                        width: 30px;
                        height: 30px;
                    }
                }
            }
            .order-msg {
                position: absolute;
                top: -2px;
                left: -104px;
                background: #fff;
                display: inline-block;
                color: rgb(166, 59, 58);
                border-radius: 10px;
                padding: 2px 10px;
                font-weight: 900;
            }
        }
        .password {
            .update-password {
                ::v-deep .el-dialog {
                    border-radius: 4px 4px 0 0;
                    width: 450px !important;
                    .el-dialog__header {
                        padding: 8px 20px;
                        background-color: rgb(166, 59, 58);
                        border-radius: 4px 4px 0 0;
                        .el-dialog__title {
                            color: #fff;
                            line-height: 26px;
                        }
                        .el-dialog__headerbtn {
                            top: 12px;
                            right: 12px;
                            .el-dialog__close {
                                color: #fff;
                            }
                        }
                    }
                    .el-dialog__body {
                        .el-form-item {
                            margin-bottom: 24px;
                            &:last-child {
                                margin: 0;
                            }
                            .el-input__inner {
                                width: 250px;
                                padding: 0 10px;
                            }
                        }
                        .el-button + .el-button {
                            margin-left: 20px;
                        }
                    }
                }
            }
        }
    }
    .el-dropdown-menu {
        top: 36px !important;
        margin: 0 !important;
        padding: 0 !important;
        border-radius: 0;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        .el-dropdown-menu__item {
            &:first-child {
                border: 0;
            }
            line-height: inherit;
            padding: 10px 20px;
            border-top: 1px solid #eee;
        }
    }
</style>
